import { createSelector } from '@reduxjs/toolkit';

import { RootState } from 'app/types';

import { initialState } from './slice';

const selectDomain = (state: RootState) => state.organizations || initialState;

export const selectOrganizations = createSelector(
  [selectDomain],
  organizationsState => organizationsState,
);
